import React from 'react';
import ReactDOM from 'react-dom';
import { Provider, ReactReduxContext } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router'
import { Route } from 'react-router';
import {PersistGate} from 'redux-persist/lib/integration/react';
import {persistStore} from 'redux-persist';
import App from './App';
import { createTheStore } from './Infrastructure/Store/store';
import { getHistory } from './utils/utils'; 
import { detect } from 'detect-browser';

const browser = detect();
let { name, os, version } = browser;
if (os !== null) {
  const osSplit = os.split(' ');
  os = osSplit[0].toLowerCase().trim();
  const osVersion = osSplit.length > 1 ? `${os}-${osSplit[1]}` : null;
  version = version.includes('.') ? version.split('.')[0] : version;
  name = name.replace(' ', '-').toLowerCase().trim();
  document.body.classList.add(name);
  document.body.classList.add(`${name}-${version}`);
  document.body.classList.add(os);    

  if(osVersion) document.body.classList.add(osVersion);
}
let history = getHistory(); 

const store = createTheStore(history);
// https://www.npmjs.com/package/redux-persist
const persistor = persistStore(store);

const setPublicPathForChunkLoading = () => {
  /* eslint-disable no-undef */
  if(window.FRONTEND_ROOT_URL){
    __webpack_public_path__ = window.FRONTEND_ROOT_URL + __webpack_public_path__;
  }
  else {
    const getCurrentScript = () => {
      const scripts = document.getElementsByTagName("script");
      return scripts[scripts.length - 1];
    };

    const getOrigin = url => url.replace(/^((\w+:)?\/\/[^/]+)\/?.*$/,'$1');

    
    const script = document.currentScript || getCurrentScript();  
    const url = getOrigin(script.src);
    __webpack_public_path__ = url + __webpack_public_path__;   
  }
  /* eslint-enable no-undef */
};

setPublicPathForChunkLoading();

if(`${name}-${version}` === "ie-11"){
  import(/* webpackChunkName: "polyfill" */ "smoothscroll-polyfill").then(smoothscroll => {
    smoothscroll.polyfill();
  });
}
ReactDOM.render(   
  <Provider store={ store} context={ReactReduxContext}>
     {/* see docs for the loading prop of PersistGate */}
    <PersistGate loading={null} persistor={persistor}>
      <ConnectedRouter history={history} context={ReactReduxContext}>
        <Route path="/" component={App} />
        {/*<App />*/}
      </ConnectedRouter> 
    </PersistGate>
  </Provider>
  ,
  document.getElementById('root'),
);